
import { Component, Vue, Ref } from 'nuxt-property-decorator';
import Modal from '../modals/Modal.vue';
import InputText from '../design-system/input/input-text/InputText.vue';
import InputTextArea from '../design-system/input/input-text/InputTextArea.vue';

interface FigureMetaModel {
  title: string;
  description: string;
}

@Component({
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    Modal,
    InputText,
    InputTextArea,
  },
})
export default class FigureModal extends Vue {
  @Ref() modal?: Modal;

  figureMetaModel: FigureMetaModel = {
    title: '',
    description: '',
  };

  public openModal(figureMetaModel: FigureMetaModel, event?: MouseEvent) {
    this.figureMetaModel = figureMetaModel;
    this.modal?.open(event?.currentTarget);
  }

  public async save() {
    if (!(await this.$validator.validateAll())) return;
    this.$emit('save', this.figureMetaModel);
    this.modal?.close();
  }

  public close() {
    this.figureMetaModel = {
      title: '',
      description: '',
    };
    this.$emit('close');
  }
}
